/**
 * W2-UX-FIX2 (Today 2.0 pixel check, defect 3): start fetching the Races route chunk before the tap.
 *
 * `App.tsx` mounts Races with `lazy(() => import('./routes/races'))`. A dynamic import of the same module is the
 * same chunk request, so calling it early from Today's race doors warms exactly the chunk the tap will need, and
 * the browser keeps it. It is a script request for a static asset: no call to the API. Safe to call again and again
 * (the module is imported once), and a failure is swallowed: the route's own `lazy` import will ask again on the tap
 * and show its own fallback if the network is still down.
 */
let started = false;

export function preloadRacesRoute(): void {
  if (started) return;
  started = true;
  import('../../routes/races').catch(() => {
    started = false;
  });
}
